import React, { Component } from "react";
// import { Table, Button } from 'react-bootstrap'
import * as storage from "../services/storage";
import PostService from "../services/PostService";
import NotificationSystem from "react-notification-system";
import { NavLink } from "react-router-dom";
import { tokenExists } from "services/TokenService";
import { FormControl, FormLabel } from "react-bootstrap";
import i18n from "../i18configuration/i18";
import { Table, Button } from 'react-bootstrap'
import { ClipLoader } from "react-spinners";

class ManageSponsored extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allPosts: undefined,
      originalPosts: undefined,
      searchText: "",
      neighborhoodChanges: {},
    };
  }

  notificationSystem = React.createRef();
  postService = new PostService();
  componentDidMount() {
    if (!tokenExists()) {
      this.props.history.push("/user/dashboard");
    }
    this.getPostsForManagement();
  }

  getPostsForManagement = () => {
    this.postService
      .getForManagement()
      .then((res) => {
        // var temp = res.data.data.sort((a, b) => { return Date.parse(b.timeToSortBy)  -Date.parse(a.timeToSortBy) })
        this.setState({
          allPosts: res.data.data,
          originalPosts: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
      });
  };

  saveFirstAdd = (postid, state) => {
    this.postService
      .saveFirstAdd(postid, state)
      .then((res) => {
        this.setState({
          allPosts: res.data.data,
          originalPosts: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
      });
  };

  saveSecondAdd = (postid, state) => {
    this.postService
      .saveSecondAdd(postid, state)
      .then((res) => {
        this.setState({
          allPosts: res.data.data,
          originalPosts: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
      });
  };

  savePopularAdd = (postid, state) => {
    this.postService
      .savePopularAdd(postid, state)
      .then((res) => {
        this.setState({
          allPosts: res.data.data,
          originalPosts: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
      });
  };

  saveSponsored = (postid, state) => {
    this.postService
      .saveSponsoredAdd(postid, state)
      .then((res) => {
        this.setState({
          allPosts: res.data.data,
          originalPosts: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
      });
  };

  getFormatedDate = (date) => {
    var dateFormated = date.split("T")[0];
    var timeFormated = date.split("T")[1];
    return dateFormated + " - " + timeFormated;
  };

  resetLocalStorage = () => {
    var notification = this.notificationSystem.current;
    try {
      storage.local.removeItem("firstAdsSlider");
      storage.local.removeItem("secondAdsArray");
      storage.local.removeItem("popular");
      storage.local.removeItem("dateSync");
      storage.local.removeItem("timeSync");
      notification.addNotification({
        message: i18n.t("Resetimi u realizua me sukses"),
        level: "success",
        position: "tc",
        autoDismiss: "5",
        dismissible: "both",
      });
    } catch (exc) {
      notification.addNotification({
        message: i18n.t("Resetimi nuk u be si duhet"),
        level: "error",
        position: "tc",
        autoDismiss: "5",
        dismissible: "both",
      });
    }
  };

  deleteForce = (postId) => {
    var notification = this.notificationSystem.current;
    this.postService
      .delete(postId)
      .then((res) => {
        notification.addNotification({
          message: i18n.t("Postimi u fshi me sukses!"),
          level: "success",
          position: "tc",
          autoDismiss: "5",
          dismissible: "both",
        });

        this.getPostsForManagement();
      })
      .catch((err) => {
        notification.addNotification({
          message: i18n.t("Problem me serverin, provoni perseri."),
          level: "error",
          position: "tc",
          autoDismiss: "5",
          dismissible: "both",
        });
      });
  };

  handleChange = () => {
    var searchText = new RegExp(this.state.searchText.toLowerCase());
    var newDataArray = this.state.originalPosts.filter((el) => {
      if (el.title != null || el.title != undefined) {
        if (
          searchText.test(el.title) ||
          searchText.test(el.description) ||
          searchText.test(el.neighborhood) ||
          searchText.test(el.userName) ||
          searchText.test(el.userEmailText)
        ) {
          return el;
        }
      }

      //   return el;
    });
    this.setState({
      allPosts: newDataArray,
    });
  };

  saveNeighborhoodChange = (postid) => {
    var neighbors = this.state.neighborhoodChanges[postid];
    const data = { neighborhood: neighbors };
    this.postService.savePostNeighborhoodChange(data, postid).then(() => {
      this.setState({ allPosts: undefined, originalPosts: undefined });
      this.getPostsForManagement();
    });
  };

  handleNeighborhoodChange = (e, postid) => {
    var temp = this.state.neighborhoodChanges;
    temp = {
      ...temp,
      [postid]: e.target.value,
    };

    this.setState({ neighborhoodChanges: temp });
  };

  handleSearch = (e) => {
    this.setState({ searchText: e.target.value });
  };
  //saveSponsoredAdd
  render() {
    const posts =
      this.state.allPosts != undefined
        ? this.state.allPosts.sort((a, b) => {
          return b.postId - a.postId;
        })
        : undefined;
    return (
      <div>
        <NotificationSystem ref={this.notificationSystem} />
        <h1 className="text-center">Menaxho postimet</h1>
        <div className="flex vertical-flex">
          <Button
            className="m-vertical-5-px"
            onClick={() => this.resetLocalStorage()}
          >
            Reseto gjendjen e dashboard (vetem per testime)
          </Button>
          <div className="flex flex-space-around wrap">
            <NavLink className="m-vertical-5-px" to="/user/list">
              <Button>Përdoruesit</Button>
            </NavLink>
            <NavLink className="m-vertical-5-px " to="/user/manage">
              <Button>Postimet</Button>
            </NavLink>
            <NavLink className="m-vertical-5-px" to="/user/visits">
              <Button>Shikueshmëria</Button>
            </NavLink>
            <NavLink className="m-vertical-5-px" to="/user/admin/add/post">
              <Button>Shto Reklamë </Button>
            </NavLink>

            <NavLink className="m-vertical-5-px" to="/user/sponsored">
              <Button>Shiko Reklamat Aktive</Button>
            </NavLink>
          </div>
        </div>
        <div className="p-2 w-100 ">
          <h4>Kërko:</h4>
          <input
            className="form-control w-100 m-0-important "
            onChange={(e) => {
              this.handleSearch(e);
            }}
            placeholder="sipas titullit, pershkrimit, lagjes, krijuesit apo emailit te tij.."
          />
          <Button
            onClick={() => {
              this.handleChange();
            }}
            className=""
          >
            Kërko
          </Button>
        </div>
        <div className="overflow-auto">
          <Table striped bordered hover className="table-manage m-3-px">
            <thead>
              <tr>
                <th>ID</th>
                <th className="w-10-vw">Titulli</th>
                <th className="w-20-vw">Pershkrimi</th>
                <th className="min-width-300">Lagjja</th>
                <th className="w-10-vw">Krijuesi</th>
                <th className="w-10-vw">emaili</th>
                <th>E krijuar me date</th>
                <th>Slider siper</th>
                <th>Slider poshte</th>
                <th>Ndertesat ne fund</th>
                <th>Te sponorizuar</th>
                <th>Fshij</th>
              </tr>
            </thead>

            {posts != undefined && posts != null && posts != {} ? (
              <tbody>
                {posts.map((post) => {
                  if (post.firstAdSlider || post.secondAdSlider || post.popular || post.sponsored)
                    return (
                      <tr key={post.postId}>
                        <td>{post.postId}</td>
                        <td className="w-10-vw">{post.title}</td>
                        <td className="w-20-vw">{post.description}</td>
                        <td className="w-20-vw">
                          <div className="flex">
                            <FormLabel>Lagja aktuale:</FormLabel>{" "}
                            {post.neighborhood}
                          </div>
                          <div className="flex">
                            <FormLabel>Lagja ekstra:</FormLabel>{" "}
                            {post.neighborhoodExtra}
                          </div>
                          <div className="flex ">
                            <FormControl
                              onChange={(e) =>
                                this.handleNeighborhoodChange(e, post.postId)
                              }
                              placeholder="Shto lagje(ndaj me hapesira)"
                            />
                            <Button
                              onClick={() =>
                                this.saveNeighborhoodChange(post.postId)
                              }
                            >
                              Ruaj
                            </Button>
                          </div>
                        </td>
                        <td className="w-10-vw">{post.userName}</td>
                        <td className="w-10-vw">{post.userEmail}</td>
                        <td>{this.getFormatedDate(post.createdAt)}</td>
                        <td>
                          <Button
                            onClick={() =>
                              this.saveFirstAdd(post.postId, post.firstAdSlider)
                            }
                            className={post.firstAdSlider ? "bg-red" : ""}
                          >
                            {post.firstAdSlider
                              ? "Remove Active"
                              : "Make Active"}
                          </Button>
                        </td>
                        <td>
                          <Button
                            onClick={() =>
                              this.saveSecondAdd(
                                post.postId,
                                post.secondAdSlider
                              )
                            }
                            className={post.secondAdSlider ? "bg-red" : ""}
                          >
                            {post.secondAdSlider
                              ? "Remove Active"
                              : "Make Active"}
                          </Button>
                        </td>
                        <td>
                          <Button
                            onClick={() =>
                              this.savePopularAdd(post.postId, post.popular)
                            }
                            className={post.popular ? "bg-red" : ""}
                          >
                            {post.popular ? "Remove Active" : "Make Active"}
                          </Button>
                        </td>
                        <td>
                          <Button
                            onClick={() =>
                              this.saveSponsored(post.postId, post.sponsored)
                            }
                            className={post.sponsored ? "bg-red" : ""}
                          >
                            {post.sponsored ? "Remove Active" : "Make Active"}
                          </Button>
                        </td>
                        <td>
                          <Button
                            onClick={() => this.deleteForce(post.postId)}
                            className="bg-red"
                          >
                            Fshij
                          </Button>
                        </td>
                      </tr>
                    );
                })}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="11" className="text-center">
                    <ClipLoader color="blue" className="loader" />
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </div>
    );
  }
}

export default ManageSponsored;
